import { render } from "./Legend.vue?vue&type=template&id=1bd00360&scoped=true"
import script from "./Legend.vue?vue&type=script&lang=js"
export * from "./Legend.vue?vue&type=script&lang=js"

import "./Legend.vue?vue&type=style&index=0&id=1bd00360&scoped=true&lang=css"

import exportComponent from "C:\\Users\\schmidch\\IdeaProjects\\soilmap\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd00360"]])

export default __exports__